import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//create action
export const createStratum = createAsyncThunk(
  "createStratum",
  async ({ data, form, history }) => {
    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };
    const response = await axiosHttp.post(
      `stratum/create`,
      data,
      config
    );

    form.resetFields();
    message.success("Stratum successfully created!");
    history("/app/employee/stratum");
    return response.data;
  }
);

const stratumCreateSlice = createSlice({
  name: "stratumCreate",
  initialState: {
    isLoading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(createStratum.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(createStratum.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(createStratum.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default stratumCreateSlice.reducer;